import styled from "styled-components";

export const AddEditCompanyMissionV2ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .content_section {
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    min-height: calc(100vh - 235px);
    border-radius: 8px;
    padding: 24px 32px;
  }

  .loading_wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
  }
`;
